export default "__VITE_ASSET__BmImb22V__"